import { defineStore } from "pinia"
import { ref } from "vue"

export const usehelpdeskUiStore = defineStore(
  "helpdeskUi",
  () => {
    const sidebarOpen = ref(true)
    const isPinned = ref(true)

    function toggleSidebar() {
      sidebarOpen.value =
        !sidebarOpen.value
    }

    function openSidebar() {
      sidebarOpen.value = true
    }

    function closeSidebar() {
      sidebarOpen.value = false
    }

    function togglePin() {
      isPinned.value =
        !isPinned.value

      if (isPinned.value) {
        sidebarOpen.value = true
      }
    }

    function setPinned(value) {
      isPinned.value =
        Boolean(value)

      if (isPinned.value) {
        sidebarOpen.value = true
      }
    }

    return {
      sidebarOpen,
      isPinned,

      toggleSidebar,
      openSidebar,
      closeSidebar,
      togglePin,
      setPinned
    }
  }
)